import { ReactElement, Suspense } from 'react';

import { IconAngleRight } from '@iwoca/icons';
import { Pill } from '@iwoca/orion';
import { Text } from '@iwoca/orion-ui';
import { NEW_IwLink } from '@iwRouter/NEW_IwLink';
import { FormattedMessage } from 'react-intl';

import { ErrorBoundary } from '../../../../../errorBoundary/ErrorBoundary';
import FallbackErrorModal from '../../../../modals/fallbackErrorModal/FallbackErrorModal';
import { MainContentBlockPending } from '../../../../pageStructure/mainContentBlockPending/MainContentBlockPending';

export const CompletedStepItem = ({
    children,
    editLink
}: {
    children: ReactElement;
    editLink?: string;
}) => (
    <ErrorBoundary fallback={() => <FallbackErrorModal />}>
        <Suspense fallback={<MainContentBlockPending />}>
            <div className="flex w-full flex-row justify-between border-b-[1px] border-b-secondary-90 py-l">
                <div className="flex w-full flex-col justify-start text-left">
                    {children}
                    {editLink && (
                        <NEW_IwLink
                            to={{
                                pathname: editLink
                            }}
                            className="my-m !justify-start text-s font-bold"
                        >
                            <FormattedMessage
                                id="_.credit_card.onboarding.check.edit.link"
                                defaultMessage="Edit"
                            />

                            <IconAngleRight />
                        </NEW_IwLink>
                    )}
                </div>
                <Pill
                    variant="green"
                    size="small"
                    className="my-auto h-xl py-0"
                >
                    <Text className="text-xs font-med text-success-drk">
                        <FormattedMessage
                            defaultMessage="Completed"
                            id="_.credit_card.onboarding.check.completed"
                        />
                    </Text>
                </Pill>
            </div>
        </Suspense>
    </ErrorBoundary>
);
